﻿import { useEffect } from "react";

export function useExtInteractionIdentifier(value: string): void {
    useEffect(() => {
        const expiery = value ? "expires=0" : "Max-Age=0";
        const secure = document.location.protocol == "https:" ? "secure" : "";

        document.cookie = `Consilio.ExtInteractionId=${value}; ${expiery}; path=/; SameSite=Strict; ${secure}`;
    }, [value]);
}
